import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Page, Card, Text, TextField, Button, Collapsible, BlockStack, InlineStack, Modal } from '@shopify/polaris';
import { PlusIcon, ChevronDownIcon, ChevronUpIcon, SaveIcon, DeleteIcon, EditIcon } from '@shopify/polaris-icons';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import { TypedFaq, useDeleteFaq, useGetFaqs, useReorderFaq } from 'queries/faq.query';
import dateandtime from 'date-and-time';
import Parser from 'html-react-parser';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import FaqCreateOrUpdateModal from './modal.createFaq';
import { Helmet } from 'react-helmet-async';
export default function Faq() {
  const {
    showDeleteConfirm
  } = useDeleteConfirm();
  const {
    mutateAsync: deleteFaq,
    isPending: deleting
  } = useDeleteFaq();
  const deleteFaqCallback = useCallback(async id => {
    const confirmed = await showDeleteConfirm('Xóa câu hỏi này?', 'Bạn có chắc muốn xóa không? Hành động này không thể khôi phục.');
    if (confirmed) {
      try {
        await deleteFaq(id);
      } catch (e) {}
    }
  }, []);

  // Fetch existing FAQs
  const {
    data: faqRawData,
    isLoading,
    isError
  } = useGetFaqs({
    page: 1,
    limit: 100,
    sort: 'question_order:asc'
  });

  // Local ordered state
  const [orderedFaqs, setOrderedFaqs] = useState<TypedFaq[]>([]);
  useEffect(() => {
    if (faqRawData) {
      const sorted = [...faqRawData.entities].sort((a, b) => a.question_order - b.question_order);
      setOrderedFaqs(sorted);
    }
  }, [faqRawData]);

  // Mutation to reorder FAQs
  const {
    mutateAsync: applyReorder
  } = useReorderFaq();

  // Track expanded item
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const onDragEnd = (result: DropResult) => {
    const {
      source,
      destination
    } = result;
    if (!destination) return;
    const items = Array.from(orderedFaqs);
    const [moved] = items.splice(source.index, 1);
    items.splice(destination.index, 0, moved);

    // Reassign orders
    const updated = items.map((faq, idx) => ({
      ...faq,
      question_order: idx + 1
    }));
    setOrderedFaqs(updated);
    applyReorder(updated.map(({
      id,
      question_order
    }) => ({
      id,
      question_order
    })));
  };

  // modal

  const [showModal, setShowModal] = useState(false);
  const currentFAQ_ID = useRef(null);
  return <>
      <Helmet>
        <title>Quản lý FAQ</title>
      </Helmet>
      <FaqCreateOrUpdateModal show={showModal} current_faq_id={currentFAQ_ID.current} onClose={() => {
      setShowModal(false);
      currentFAQ_ID.current = null;
    }} />
      <Page title="FAQ" primaryAction={{
      icon: PlusIcon,
      content: 'Add FAQ',
      onAction: () => {
        currentFAQ_ID.current = null;
        setShowModal(true);
      }
    }}>
        {isLoading && <Card>Loading FAQs...</Card>}
        {isError && <Card>Failed to load FAQs.</Card>}

        {!isLoading && !isError && <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="faq-list">
              {provided => <div {...provided.droppableProps} ref={provided.innerRef}>
                  {orderedFaqs.map((faq, index) => <Draggable key={faq.id} draggableId={faq.id} index={index}>
                      {draggableProvided => <div ref={draggableProvided.innerRef} {...draggableProvided.draggableProps} {...draggableProvided.dragHandleProps} style={{
                marginBottom: '1rem',
                ...draggableProvided.draggableProps.style
              }}>
                          <Card>
                            <InlineStack align="start" gap="200" blockAlign="center">
                              <Button variant="plain" icon={expandedIndex === index ? ChevronUpIcon : ChevronDownIcon} onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}>
                                {faq.question}
                              </Button>
                            </InlineStack>

                            <Collapsible open={expandedIndex === index} id={`faq-${faq.id}`}>
                              <BlockStack gap="400">
                                <br />
                                <Text as="p" variant="bodyMd">
                                  {Parser(faq.answer)}
                                </Text>
                                <Text as="p" variant="bodySm" tone="subdued">
                                  Cập nhật lúc {dateandtime.format(new Date(Number(faq.createdAt)), 'DD/MM/YYYY HH:mm:ss')}
                                </Text>
                                <InlineStack gap="400">
                                  <Button icon={EditIcon} size="slim" onClick={() => {
                          currentFAQ_ID.current = faq.id;
                          setShowModal(true);
                        }}>
                                    Chỉnh sửa
                                  </Button>
                                  <Button tone="critical" loading={deleting} size="slim" icon={DeleteIcon} onClick={() => deleteFaqCallback(faq.id)}>
                                    Xóa
                                  </Button>
                                </InlineStack>
                              </BlockStack>
                            </Collapsible>
                          </Card>
                        </div>}
                    </Draggable>)}
                  {provided.placeholder}
                </div>}
            </Droppable>
          </DragDropContext>}
      </Page>
    </>;
}